import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {}

const actions = {
    // 获取题库管理列表
    getQuestionList({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['questionBank:bank:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank`,
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })                
                }else {
                    resolve()
                }
            })
        })
    },

    // 创建题库
    postQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank`,
                method: "post",
                data: data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑题库
    putQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/${data.id}`,
                method: "put",
                data: data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 删除题库
    deleteQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/${data}`,
                method: "delete",
                data: { id: data }
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}